import { CallListDrawer } from '../drawers/CallListDrawer';
import { CreateCallDrawer } from '../drawers/CreateCallDrawer';
import { CreateSendoutDrawer } from '../drawers/CreateSendoutDrawer';
import { CreateSendoverDrawer } from '../drawers/CreateSendoverDrawer';
import { DraftsDrawer } from '../drawers/DraftsDrawer';
import { DuplicatesDrawer } from '../drawers/DuplicatesDrawer';
import { SendoutDetailsDrawer } from '../drawers/SendoutDetailsDrawer';
import { SendoverDetailsDrawer } from '../drawers/SendoverDetailsDrawer';

export const DRAWER_TYPES = {
  CreateSendout: 'CreateSendout',
  CreateSendover: 'CreateSendover',
  SendoutDetails: 'SendoutDetails',
  SendoverDetails: 'SendoverDetails',
  CallList: 'CallList',
  CreateCall: 'CreateCall',
  Drafts: 'Drafts',
  Duplicates: 'Duplicates'
};

export const DRAWER_REGISTRY_MAP = {
  [DRAWER_TYPES.CreateSendout]: CreateSendoutDrawer,
  [DRAWER_TYPES.CreateSendover]: CreateSendoverDrawer,
  [DRAWER_TYPES.SendoverDetails]: SendoverDetailsDrawer,
  [DRAWER_TYPES.CallList]: CallListDrawer,
  [DRAWER_TYPES.CreateCall]: CreateCallDrawer,
  [DRAWER_TYPES.Drafts]: DraftsDrawer,
  [DRAWER_TYPES.Duplicates]: DuplicatesDrawer,
  [DRAWER_TYPES.SendoutDetails]: SendoutDetailsDrawer
};
